module.exports = __webpack_public_path__ + "images/root/bg_award_670518aefb44f52488cfefc6dd01f989.svg";